import { carouselData } from '@/mocks/homepage';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">焦点专题</h2>
          <p className="text-sm text-foreground-500 mt-2">深度策划 · 不容错过的精彩专题</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselData.map((item) => (
            <div key={item.id} className="bg-background-50 rounded-2xl overflow-hidden group cursor-pointer">
              <div className="aspect-[2/1] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 object-top"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    const parent = target.parentElement;
                    if (parent) parent.classList.add('hidden');
                  }}
                />
              </div>
              <div className="p-5">
                <span className="inline-block px-2.5 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-2 whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className="text-base font-heading font-bold text-foreground-900 group-hover:text-primary-600 transition-colors leading-snug">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 mt-2 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}